import EquationParser from 'scoreboard/components/equations/equation-parser'

var fieldEquationParser = new EquationParser({
	patternKeys: [ 'COLUMN_PATTERN_STRING' ],
	methods: [ 'columnOrField' ]
})

fieldEquationParser.columnOrField = function(parsed) {
	let basics = {
		match: parsed[0],
		type: 'columnOrField'
	}
	if (parsed[2]) {
		basics.dataset = parsed[1]
		basics.field = parsed[2]
	} else {
		basics.columnOrField = parsed[1]
	}
	return basics
}

export default fieldEquationParser

fieldEquationParser.__filename__ = 'datasets/edit/fields/field-equation-parser.js'
